const responsive = {
  small: 768,
  medium: 1024,
  large: 1440,
  xlarge: 1920,
};

export default responsive;
